import { SVGProps, useId } from "react";

export default function CalendarClockIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 80, width = 80, ...rest } = props;
  const uniqueId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M42.351 74.375H7.70025C3.799 74.375 0.625 71.2013 0.625 67.2998V12.7003C0.625 8.79875 3.79875 5.625 7.70025 5.625H67.2998C71.201 5.625 74.375 8.79875 74.375 12.7003V42.35C74.375 43.3853 73.5352 44.225 72.5 44.225C71.4648 44.225 70.625 43.3853 70.625 42.35V12.7003C70.625 10.8668 69.1333 9.375 67.2998 9.375H7.70025C5.86675 9.375 4.375 10.8668 4.375 12.7003V67.2998C4.375 69.1333 5.86675 70.625 7.70025 70.625H42.3512C43.3865 70.625 44.2262 71.4648 44.2262 72.5C44.2262 73.5352 43.3862 74.375 42.351 74.375Z"
        fill={`url(#paint0_linear_${uniqueId})`}
      />
      <path
        d="M72.5 24.375H2.5C1.46475 24.375 0.625 23.5352 0.625 22.5C0.625 21.4648 1.46475 20.625 2.5 20.625H72.5C73.5352 20.625 74.375 21.4648 74.375 22.5C74.375 23.5352 73.5352 24.375 72.5 24.375Z"
        fill={`url(#paint1_linear_${uniqueId})`}
      />
      <path
        d="M37.5 14.375C36.4648 14.375 35.625 13.5352 35.625 12.5V2.5C35.625 1.46475 36.4648 0.625 37.5 0.625C38.5352 0.625 39.375 1.46475 39.375 2.5V12.5C39.375 13.5352 38.5352 14.375 37.5 14.375Z"
        fill={`url(#paint2_linear_${uniqueId})`}
      />
      <path
        d="M12.5 14.375C11.4648 14.375 10.625 13.5352 10.625 12.5V2.5C10.625 1.46475 11.4648 0.625 12.5 0.625C13.5352 0.625 14.375 1.46475 14.375 2.5V12.5C14.375 13.5352 13.5352 14.375 12.5 14.375Z"
        fill={`url(#paint3_linear_${uniqueId})`}
      />
      <path
        d="M62.5 14.375C61.4648 14.375 60.625 13.5352 60.625 12.5V2.5C60.625 1.46475 61.4648 0.625 62.5 0.625C63.5352 0.625 64.375 1.46475 64.375 2.5V12.5C64.375 13.5352 63.5352 14.375 62.5 14.375Z"
        fill={`url(#paint4_linear_${uniqueId})`}
      />
      <path
        d="M22.5 44.375H12.5C11.4648 44.375 10.625 43.5352 10.625 42.5V32.5C10.625 31.4648 11.4648 30.625 12.5 30.625H22.5C23.5352 30.625 24.375 31.4648 24.375 32.5V42.5C24.375 43.5352 23.5352 44.375 22.5 44.375ZM14.375 40.625H20.625V34.375H14.375V40.625Z"
        fill={`url(#paint5_linear_${uniqueId})`}
      />
      <path
        d="M42.5 44.375H32.5C31.4648 44.375 30.625 43.5352 30.625 42.5V32.5C30.625 31.4648 31.4648 30.625 32.5 30.625H42.5C43.5352 30.625 44.375 31.4648 44.375 32.5V42.5C44.375 43.5352 43.5352 44.375 42.5 44.375ZM34.375 40.625H40.625V34.375H34.375V40.625Z"
        fill={`url(#paint6_linear_${uniqueId})`}
      />
      <path
        d="M22.5 64.375H12.5C11.4648 64.375 10.625 63.5352 10.625 62.5V52.5C10.625 51.4648 11.4648 50.625 12.5 50.625H22.5C23.5352 50.625 24.375 51.4648 24.375 52.5V62.5C24.375 63.5352 23.5352 64.375 22.5 64.375ZM14.375 60.625H20.625V54.375H14.375V60.625Z"
        fill={`url(#paint7_linear_${uniqueId})`}
      />
      <path
        d="M62.5 79.375C53.1958 79.375 45.625 71.8055 45.625 62.5C45.625 53.1945 53.1958 45.625 62.5 45.625C71.8043 45.625 79.375 53.1945 79.375 62.5C79.375 71.8055 71.8043 79.375 62.5 79.375ZM62.5 49.375C55.2638 49.375 49.375 55.2625 49.375 62.5C49.375 69.7375 55.2638 75.625 62.5 75.625C69.7362 75.625 75.625 69.7375 75.625 62.5C75.625 55.2625 69.7362 49.375 62.5 49.375Z"
        fill={`url(#paint8_linear_${uniqueId})`}
      />
      <path
        d="M67.5 64.375H62.5C61.4648 64.375 60.625 63.5352 60.625 62.5V55C60.625 53.9648 61.4648 53.125 62.5 53.125C63.5352 53.125 64.375 53.9648 64.375 55V60.625H67.5C68.5353 60.625 69.375 61.4648 69.375 62.5C69.375 63.5352 68.5353 64.375 67.5 64.375Z"
        fill={`url(#paint9_linear_${uniqueId})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${uniqueId}`}
          x1="37.5"
          y1="5.625"
          x2="37.5"
          y2="74.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${uniqueId}`}
          x1="37.5"
          y1="20.625"
          x2="37.5"
          y2="24.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_linear_${uniqueId}`}
          x1="37.5"
          y1="0.625"
          x2="37.5"
          y2="14.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_linear_${uniqueId}`}
          x1="12.5"
          y1="0.625"
          x2="12.5"
          y2="14.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint4_linear_${uniqueId}`}
          x1="62.5"
          y1="0.625"
          x2="62.5"
          y2="14.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint5_linear_${uniqueId}`}
          x1="17.5"
          y1="30.625"
          x2="17.5"
          y2="44.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint6_linear_${uniqueId}`}
          x1="37.5"
          y1="30.625"
          x2="37.5"
          y2="44.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint7_linear_${uniqueId}`}
          x1="17.5"
          y1="50.625"
          x2="17.5"
          y2="64.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint8_linear_${uniqueId}`}
          x1="62.5"
          y1="45.625"
          x2="62.5"
          y2="79.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint9_linear_${uniqueId}`}
          x1="65"
          y1="53.125"
          x2="65"
          y2="64.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
